// components
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";
import CommonForm from "../Common/CommonForm";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AttachFileIcon from "@mui/icons-material/Assignment";


class ConfidentialAttachmentAddMember extends CommonActionModal {
    async componentDidMount() {
        let formFields = await this.retrieveFields();
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Добавить',
            buttonColor: 'neutral',
            modalLabel: 'Добавить участника команды вложения',
            modalIcon: AttachFileIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
            ready: true,
        })
    }

    async retrieveFields(){
        const api = new BaseApi();
        let url = `subscriber/`;
        let response = await api.get(
            url,
            {
                active: true,
                page_size: 10000,
            }
        );
        return [
            {
                'name': 'member',
                'label': 'Участник команды',
                'xs': 12,
                'sm': null,
                'md': null,
                'lg': null,
                'xl': null,
                'required': false,
                'default': null,
                'type': 'select',
                'options': response.data.results.map((each) => (
                    {'value': each.id, 'label': `${each.user.first_name} ${each.user.last_name}`}
                ))
            },
            {
                type: 'submit',
                label: 'Готово!'
            }
        ]
    }

    async processForm(form) {
        let formData = form.state.formData;
        const url = `confidential_attachment/${this.props.attachment.id}/add_member/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formData,
            true,
        );
        if (response.status === 200) {
            if (this.props.callBack) {
                await this.props.callBack();
            }
            this.setModalOpenFalse()
        }
        return response
    }
}

export default ConfidentialAttachmentAddMember
